import React from 'react';
import IconButton from '@mui/material/IconButton';
import CheckBoxChecked from '@mui/icons-material/CheckBox';
import CheckBoxBlank from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';

import { update } from 'lodash';

const style = {
    paper: {
        padding:"10px 20px 10px 20px",
        backgroundColor:"#fcffc9",
    }
}

const UnterschriftHaken = (props) => (
    <FormControl component="fieldset">
      <FormGroup aria-label="position" row>

        <FormControlLabel
          value="top"
          control={
            <Checkbox
              onChange={()=>{
                if (props.value) {
                  props.update(false)
                  return
                }
                props.update(true)
              }}
              checked={props.value===true}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
            />
          }
          label="Hiermit bestätige ich, dass meine Angaben richtig und vollständig sind."
          labelPlacement="end"
        />   

      </FormGroup>
  </FormControl>
)

export default UnterschriftHaken;







